import React, { Component } from 'react';


export class PageWrapper extends Component {
  render() {
    return (
      <div className="PageWrapper">
        { !this.props.hideHeader &&
          <div>
            Header
          </div>
        }

        <div>
          { this.props.children }
        </div>

        { !this.props.hideFooter &&
          <div>
            Footer
          </div>
        }
      </div> 
    )
  }
}
